import * as React from "react"

import GenericIconProps from './_icon.type';

function ButtonArrowIcon({className}: GenericIconProps) {
  return (
    <svg
      className={className || ''}
      width="20"
      height="20"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.4819 0.159394C10.4256 0.211163 10.3805 0.272915 10.3495 0.341121C10.3184 0.409326 10.3018 0.482647 10.3008 0.556893C10.2997 0.631137 10.3142 0.70485 10.3433 0.773819C10.3724 0.842788 10.4157 0.90566 10.4706 0.95884L13.4723 3.79243L1.11405 3.79243C1.03411 3.79065 0.954588 3.80398 0.880176 3.83163C0.805763 3.85928 0.737958 3.9007 0.680747 3.95345C0.623536 4.0062 0.578075 4.06922 0.547036 4.1388C0.515997 4.20838 0.500008 4.28312 0.500008 4.35861C0.500008 4.43411 0.515997 4.50885 0.547036 4.57843C0.578075 4.64801 0.623536 4.71103 0.680747 4.76378C0.737958 4.81653 0.805763 4.85795 0.880175 4.8856C0.954588 4.91325 1.03411 4.92658 1.11405 4.9248L13.4947 4.9248L10.4669 7.77955L10.4555 7.79029C10.4006 7.84349 10.3573 7.90638 10.3281 7.97537C10.299 8.04436 10.2845 8.1181 10.2855 8.19238C10.2865 8.26666 10.303 8.34002 10.334 8.40828C10.3651 8.47654 10.41 8.53836 10.4664 8.59021C10.5227 8.64206 10.5894 8.68292 10.6624 8.71047C10.7355 8.73801 10.8136 8.7517 10.8923 8.75075C10.971 8.74979 11.0487 8.73422 11.121 8.70491C11.1933 8.67561 11.2588 8.63314 11.3137 8.57995L15.3382 4.7795C15.4505 4.67347 15.5138 4.52986 15.5145 4.37994L15.5145 4.35498C15.5139 4.20495 15.4506 4.06121 15.3382 3.9551L11.3174 0.162553C11.206 0.0589544 11.0562 0.000616199 10.8998 2.58732e-05C10.7435 -0.000564453 10.5932 0.0566388 10.4809 0.159394L10.4819 0.159394Z" />
    </svg>
  )
}

export default ButtonArrowIcon;
